import React from 'react';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';
export function ArchitectSubmittedPage() {
  return <>
      <SEO title="Project Submission Received — Aspect" description="Your project submission has been received. We'll review and follow up within one business day." data-id="element-110" />
      <div className="max-w-2xl" data-id="element-111">
        <h1 className="text-3xl md:text-4xl font-medium leading-tight mb-16 text-aspect-black" data-id="element-112">
          Project submission received
        </h1>

        <div className="space-y-16" data-id="element-113">
          <section data-id="element-114">
            <p className="text-lg text-aspect-black/80 leading-relaxed" data-id="element-115">
              We've received your project details.
            </p>
          </section>

          <section className="space-y-4" data-id="element-116">
            <h2 className="text-xl font-medium text-aspect-black" data-id="element-117">
              What happens next
            </h2>
            <p className="text-aspect-black/80 leading-relaxed" data-id="element-118">
              Our team will review the submission and follow up to coordinate
              photography, scope, and approvals.
            </p>
          </section>

          <section className="space-y-4" data-id="element-119">
            <h2 className="text-xl font-medium text-aspect-black" data-id="element-120">Timing</h2>
            <p className="text-aspect-black/80 leading-relaxed" data-id="element-121">
              We typically respond within one business day.
            </p>
          </section>

          <section className="space-y-4" data-id="element-122">
            <h2 className="text-xl font-medium text-aspect-black" data-id="element-123">Reference</h2>
            <p className="text-aspect-black/80 leading-relaxed" data-id="element-124">
              Details on rights, attribution, and review controls are available
              in the{' '}
              <Link to="/faq#architects" className="text-aspect-black underline hover:text-aspect-black/70" data-id="element-125">
                Architect FAQs
              </Link>
            </p>
          </section>
        </div>
      </div>
    </>;
}